$(document).on('change','#staff_list_upload_input',function(e){
    $('#staffListUploadFilename').text(e.target.files[0].name);
    document.getElementById("staff_list_upload_btn").disabled = false;
});

$(document).on('input','#settingsForUploadedFileModal  #skipRows',function(e){
    if(+$(this).val() < 0)
        $(this).val(0)
});

window.Integration = {
    getPreview: function() {
        if(document.getElementById("staff_list_upload_input").files.length == 0 )
        {
            Swal.fire({icon:'warning' ,title:'Выберите файл'});
            return;
        }
        const self = this;
        let formData = new FormData($('#staffListUploadForm').get(0));

        this.swalLoader();

        $.ajax({
            url: '/get_preview',
            type: 'POST',
            contentType: false, // важно - убираем форматирование данных по умолчанию
            processData: false, // важно - убираем преобразование строк по умолчанию
            dataType: 'JSON',
            data: formData,
            success: function(data){
                //fill columns
                let sHtmlSelectInput = '<div class="form-group col-md-4">';
                sHtmlSelectInput += '<select class="form-control arrayChoicesForColumn">';

                for(let sColumnName in data.aColumnsForSelectedInput){
                    sHtmlSelectInput += '<option value="'+sColumnName+'">'+data.aColumnsForSelectedInput[sColumnName].title+'</option>';
                }
                sHtmlSelectInput += '</select>';
                sHtmlSelectInput += '</div>';

                let sHtmlComparisonRaws = '';
                const oTemplate = data.oTemplate;
                const aTemplateColumns = oTemplate ? oTemplate.comparison_columns : undefined;
                const aTemplateSettings = oTemplate ? oTemplate.settings : undefined;
                for(let sColumnNum in data.aColumnsFromList)
                {
                    const sColumnID = 'column'+sColumnNum;
                    const sDefaultSelectedOptionValue = aTemplateColumns && aTemplateColumns[sColumnID] ? aTemplateColumns[sColumnID] : 'ignore';
                    sHtmlComparisonRaws += `<div class="row" id="${sColumnID}" style="align-items: baseline;">`;
                    sHtmlComparisonRaws += sHtmlSelectInput.replace(`option value="${sDefaultSelectedOptionValue}"`, `option value="${sDefaultSelectedOptionValue}" selected`);
                    sHtmlComparisonRaws += '<small class="text">';
                    sHtmlComparisonRaws += data.aColumnsFromList[sColumnNum];
                    sHtmlComparisonRaws += '</small>';
                    sHtmlComparisonRaws += '</div>';
                }
                $('#comparisonColumnsModalBody').html(sHtmlComparisonRaws);
                //fill columns

                $('#comparisonColumnsModalFileId').val(data.iFileId);

                //fill settings from template
                for (const prop in aTemplateSettings) {
                    switch(prop) {
                        case 'iSkipRows':
                            $('#settingsForUploadedFileModalBody #skipRows').val(aTemplateSettings[prop]);
                        break;
                        case 'bCreateRMSWorkspaces':
                            $('#settingsForUploadedFileModalBody #createRMSWorkspaces').prop('checked', aTemplateSettings[prop] == 'true' ? true : false);
                        break;
                        case 'sWhatUpload':
                            $("#settingsForUploadedFileModalBody [name='whatUpload']").each(function(index){
                                if($(this).val() == aTemplateSettings[prop])
                                    $(this).prop('checked', true)
                            });
                        break;
                        case 'bIsRefreshed':
                            $("#settingsForUploadedFileModalBody [name='isRefreshed']").each(function(index){
                                if($(this).val() == aTemplateSettings[prop])
                                    $(this).prop('checked', true)
                            });
                        break;
                        default:
                        break;
                    }
                }
                //fill settings from template

                //show or hide template buttons
                const aExistsTypes = [];
                const aNotExistsTypes = [];

                aTemplateColumns ? aExistsTypes.push('comparison_columns') : aNotExistsTypes.push('comparison_columns');
                aTemplateSettings ? aExistsTypes.push('settings') : aNotExistsTypes.push('settings');

                oTemplate && oTemplate.id ? self.template.setTemplateExists(oTemplate.id, aExistsTypes) : false;
                self.template.setTemplateNotExists(aNotExistsTypes)
                //show or hide template buttons

                Swal.close();

                $('#comparisonColumnsModal').modal({
                    backdrop: 'static',
                    keyboard: false
                });
            },
            error: function(data) {
              Swal.fire({icon:'warning', title: data.responseText});
            }
        });
    },
    template: {
        getSaveButton: function(sType) {
            return document.querySelector(`#AllStaffListIntagrationModalsId #saveTemplateButton[data-template-type="${sType}"]`);
        },
        getRemoveButton(sType) {
            return document.querySelector(`#AllStaffListIntagrationModalsId #removeTemplateButton[data-template-type="${sType}"]`);
        },
        saveTemplate: function(buttonNode) {
            const type = buttonNode.dataset.templateType;
            let oData = {};

            switch(type) {
                case 'comparison_columns':
                    oData[type] = window.Integration.parseComparisonColumns();
                break;
                case 'settings':
                    oData[type] = window.Integration.parseSettings();
                break;
                default:
                    return;
                break;
            }

            window.Integration.swalLoader();

            const self = this;

            $.ajax({
                url: '/save_template',
                type: 'POST',
                data: oData,
                dataType: 'JSON',
                success: function(data){
                    toastr.success(data.message);
                    if(data.id)
                        self.setTemplateExists(data.id, [type])
                },
                complete: function(){
                    Swal.close();
                },
                error: function(data) {
                    toastr.error(data.responseJSON.message);
                }
            });
        },
        removeTemplate: function(buttonNode) {
            const iTemplateId = buttonNode.dataset.templateId;
            if(!iTemplateId)
                return;
            const self = this;

            const type = buttonNode.dataset.templateType;
            let oData = {};

            switch(type) {
                case 'comparison_columns':
                    oData.type = type;
                break;
                case 'settings':
                    oData.type = type;
                break;
                default:
                    return;
                break;
            }

            Swal.fire({
                title: window.HSE_lang.sure,
                icon: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn-danger",
                cancelButtonText: window.HSE_lang.close,
                confirmButtonText: window.HSE_lang.delete,
                preConfirm: (message) => {
                    window.Integration.swalLoader();
                    $.ajax({
                        url: '/remove_template/'+iTemplateId,
                        type: 'PUT',
                        data: oData,
                        dataType: 'JSON',
                        success: function(data){
                            toastr.success(data.message);
                            self.setTemplateNotExists([type]);
                        },
                        complete: function(){
                            Swal.close();
                        },
                        error: function(data) {
                            toastr.error(data.responseJSON.message);
                        }
                    });
                }
            });
        },
        setTemplateExists: function($iId, aTypes = []) {
            aTypes.forEach(sType => {
                this.hideSaveButton(sType);
                this.showRemoveButton(sType);
                this.getRemoveButton(sType).dataset.templateId = $iId;
            })
        },
        setTemplateNotExists: function(aTypes = []) {
            aTypes.forEach(sType => {
                this.hideRemoveButton(sType);
                this.showSaveButton(sType);
                this.getRemoveButton(sType).dataset.templateId = '';
            })
        },
        showSaveButton(sType) {
            this.getSaveButton(sType).parentNode.classList.remove('d-none');
        },
        hideSaveButton(sType) {
            this.getSaveButton(sType).parentNode.classList.add('d-none');
        },
        showRemoveButton(sType) {
            this.getRemoveButton(sType).parentNode.classList.remove('d-none');
        },
        hideRemoveButton(sType) {
            this.getRemoveButton(sType).parentNode.classList.add('d-none');
        },
    },
    applyComparison: function()
    {
        let oComparison = this.parseComparisonColumns();

        let oFormData = {};

        oFormData.comparison = oComparison;
        oFormData.file_id = $('#comparisonColumnsModalFileId').val();
        oFormData.main_name = $('#mainNameForIntegration').val();

        this.swalLoader();

        $.ajax({
            url: '/set_comparison_columns',
            type: 'POST',
            dataType: 'JSON',
            data: oFormData,
            success: function(data){
                $('#settingsForUploadedFileModalFileId').val(data.iFileId);

                Swal.close();

                $('#settingsForUploadedFileModal').modal({
                    backdrop: 'static',
                    keyboard: false
                });
            },
            error: function(data) {
              Swal.fire({icon:'warning', title: data.responseText});
            }
        });
    },
    parseComparisonColumns() {
        let oComparison = {};

        $('#comparisonColumnsModal #comparisonColumnsModalBody .row').each(function( index )
        {
            let columnNum = $( this ).attr('id');
            let selectedChoice = $(this).find('.arrayChoicesForColumn').val();
            oComparison[columnNum] = selectedChoice;
        });

        return oComparison;
    },
    startUploading: function()
    {
        let oSettingsForUpload = {};
        oSettingsForUpload.aMainInfo = {};
        oSettingsForUpload.aSettings = this.parseSettings();
        oSettingsForUpload.aMainInfo.file_id = $('#settingsForUploadedFileModalFileId').val();
        oSettingsForUpload.aMainInfo.main_name = $('#mainNameForIntegration').val();
        oSettingsForUpload.aMainInfo.company_id = document.forms.formWrapperForQFields.company_id.value;

        this.swalLoader();

        $.ajax({
            url: '/start_uploading',
            type: 'POST',
            dataType: 'JSON',
            data: oSettingsForUpload,
            success: function(data){
                $('body').find('#AllStaffListIntagrationModalsId').children().modal('hide');
                Swal.close();
                Swal.fire({icon: data.status, title: data.message});
            },
            error: function(data) {
              Swal.fire({icon:'warning', title: data.responseText});
            }
        });
    },
    parseSettings: function() {
        let aSettings = {};

        $("[name='whatUpload']").each(function(index){
            let checked = $(this).prop('checked');
            if(checked) aSettings.sWhatUpload = $(this).val();
        });

        $("[name='isRefreshed']").each(function(index){
            let checked = $(this).prop('checked');
            if(checked) aSettings.bIsRefreshed = $(this).val();
        });

        aSettings.iSkipRows = +$('#settingsForUploadedFileModalBody #skipRows').val() ? +$('#settingsForUploadedFileModalBody #skipRows').val() : 0;
        aSettings.bCreateRMSWorkspaces = $('#settingsForUploadedFileModalBody #createRMSWorkspaces').prop('checked');

        return aSettings;
    },
    swalLoader: function(sMessage = 'Обрабатываем файл, ожидайте')
    {
        Swal.fire({
            title: sMessage,
            heightAuto:false,
            showLoaderOnConfirm: true,
            focusConfirm: false,
            showCancelButton: false,
            target: 'body',
            allowOutsideClick:false,
            allowEscapeKey:false,
            onBeforeOpen: () => {
                Swal.showLoading()
            }
        });
    }
}
